import React from "react";
import * as Rb from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import * as Bi from "react-icons/bs";
class Eduex extends React.Component
{
    render(){
        return(
            <div className="top_align mb-2">
                <Rb.Card className="shadow card_align">
                        <Rb.Card.Body>
                            <section>
                                <div className="main_header">
                                    <h1 className="">Experience & Education</h1>
                                    <div className="divider"></div>
                                </div>
                                {/* Experience */}
                                <div className="mt-4">
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="d-flex justify-content-center">
                                                <span className="box_1 box  text-center">
                                                    <Bi.BsEnvelope className="profile_icon y_color"/>
                                                </span>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="my-auto">
                                        <div className="sub_heading ">
                                            <h2 className="mb-0">Experience</h2>
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                    {/* Saneforce */}
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="position-relative">
                                                <div className="time_line mx-auto"></div>
                                                <div className="tl_bcir"></div>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="">
                                        <div className="sub_heading ">
                                            <h6 className="mb-0 mt-4 w_color">Saneforce Product Company (Web & Mobile Ui Developer)</h6>
                                            <p className="y_txt_color fw-4 mt-2">Aug/2022 - Present</p>
                                            <ul className="mt-2">
                                                <li>Working in a PAYROLL TEAM</li>
                                                <li>Responsible for Web and Mobile complete Ui Development</li>
                                                <li>Developing a new modules based on client requirement</li>
                                            </ul>
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                    {/* tag technology */}
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="position-relative">
                                                <div className="time_line mx-auto"></div>
                                                <div className="tl_bcir"></div>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="">
                                        <div className="sub_heading ">
                                            <h6 className="mb-0 mt-4 w_color">Tag Technology Services (UI/UX Design and Developer)</h6>
                                            <p className="y_txt_color fw-4 mt-2">June/2021 - July/2022</p>
                                            
                                            <ul className="mt-2">
                                                <li>Responsible for creating, improving, and developing IT projects and understanding work strategies</li>
                                                <li>Updates and maintains previous projects in wordpress</li>
                                                <li>Implemented successful application design and effective front end develop.</li>
                                            </ul>
                                            
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                    {/* Icici */}
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="position-relative">
                                                <div className="time_line mx-auto"></div>
                                                <div className="tl_bcir"></div>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="">
                                        <div className="sub_heading ">
                                            <h6 className="mb-0 mt-4 w_color">ICICI Prudential Life Insurance (Financial Services Consultant)</h6>
                                            <p className="y_txt_color fw-4 mt-2">Aug/2020 - March/2021</p>
                                            
                                            <ul className="mt-2">
                                                <li>Responsible for explaining policies and convincing customers</li>
                                                <li>Will perform monthly targets and be responsible for branch bwrp rating</li>
                                            </ul>
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                </div>
                                {/* Education */}
                                <div className="mt-5">
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="d-flex justify-content-center">
                                                <span className="box_1 box  text-center">
                                                    <Bi.BsEnvelope className="profile_icon y_color"/>
                                                </span>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="my-auto">
                                        <div className="sub_heading ">
                                            <h2 className="mb-0">Education</h2>
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                    {/* Saneforce */}
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="position-relative">
                                                <div className="time_line mx-auto"></div>
                                                <div className="tl_bcir"></div>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="">
                                        <div className="sub_heading ">
                                            <h6 className="mb-0 mt-4 w_color">MBA Business Analytics</h6>
                                            <p className="y_txt_color fw-4 mt-2">2022 - 2024</p>
                                            <p className="mb-0">SRM University</p>
                                            <p className="mb-0">CGP : 8.5</p>
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                    {/* tag technology */}
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="position-relative">
                                                <div className="time_line mx-auto"></div>
                                                <div className="tl_bcir"></div>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="">
                                        <div className="sub_heading ">
                                            <h6 className="mb-0 mt-4 w_color">Bsc Computer Science</h6>
                                            <p className="y_txt_color fw-4 mt-2">2017 - 2020</p>
                                            <p className="mb-0">K.C.S kasi nadar college of atrs and science</p>
                                            <p className="mb-0">Percentage: 75</p>
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                    {/* Icici */}
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="position-relative">
                                                <div className="time_line mx-auto"></div>
                                                <div className="tl_bcir"></div>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="">
                                        <div className="sub_heading ">
                                            <h6 className="mb-0 mt-4 w_color">HSC Computer Science</h6>
                                            <p className="y_txt_color fw-4 mt-2">2016 - 2017</p>
                                            <p className="mb-0">Soundrapandian suppamma girls hr.sec.school</p>
                                            <p className="mb-0">Percentage: 71</p>
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                    <Rb.Row>
                                        <Rb.Col sm={1} md={1} lg={1} xl={1} xxl={1}>
                                            <div className="position-relative">
                                                <div className="time_line mx-auto"></div>
                                                <div className="tl_bcir"></div>
                                            </div>
                                            
                                        </Rb.Col>
                                        <Rb.Col sm={11} md={11} lg={11} xl={11} xxl={11} className="">
                                        <div className="sub_heading ">
                                            <h6 className="mb-0 mt-4 w_color">SSLC Genereal</h6>
                                            <p className="y_txt_color fw-4 mt-2">2014-2015</p>
                                            <p className="mb-0">Soundrapandian suppamma girls hr.sec.school</p>
                                            <p className="mb-0">Percentage: 83</p>
                                        </div>
                                        </Rb.Col>
                                    </Rb.Row>
                                </div>
                            </section>
                        </Rb.Card.Body>
                    </Rb.Card>
                </div>
                
        )
    }
}
export default Eduex